import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { LIBRARY_SERVICE_METHOD, USER_PLAN_SERVICE_METHOD, USER_SERVICES_METHOD } from "services/commonService";
import { PlanDetailState } from "./PlanDetail";

const SLICE = "planDetails";

const initialState: PlanDetailState = {
  planDetails: [],
  isBookmarked: false,
  status: "idle",
  planDetailShowLoader: false,
  commentShowLoader: false,
  copySectionData: {
    copySectionType: false,
    dialogTitle: "",
    sectionPayload: []
  },
  implementedPlansToJoin: [],
  implementedPlansLoader: false,
  memberDetails: [],
  isShareablePlan: false
};

export const fetchPlanDetailAsync = createAsyncThunk("planDetails", (data: any, thunkApi) => {
  const { planId, innCode, otherInnCodes, fetchAllImplementedPlans, brandCode, region, mgmtType, locationType } = data;
  const param = {
    ...(otherInnCodes && { otherInnCodes }),
    ...(!brandCode && !region && !mgmtType && !locationType ? { innCode } : {}),
    ...(brandCode && { brandCode }),
    ...(region && { region }),
    ...(mgmtType && { mgmtType }),
    ...(locationType && { locationType }),
    fetchAllImplementedPlans,
    isIndependentTargets: !brandCode && !region && !mgmtType && !locationType ? false : true
  };
  return apiRequest(LIBRARY_SERVICE_METHOD.getPlans, {}, thunkApi, [planId], param);
});

export const fetchImplementedPlansAsync = createAsyncThunk(
  `${SLICE}/fetchImplementedPlansAsync`,
  (data: any, thunkApi) => {
    return apiRequest(USER_PLAN_SERVICE_METHOD.postPlans, data, thunkApi, ["implementations"]);
  }
);

export const fetchUserDetailsAsync = createAsyncThunk(`${SLICE}/fetchUserDetails`, (data: any, thunkApi) => {
  return apiRequest(USER_SERVICES_METHOD.getAssociates, {}, thunkApi, [], data);
});

export const joiningToPlanAsync = createAsyncThunk(`${SLICE}/joiningToPlanAsync`, (data: any, thunkApi) => {
  const { id, isHotelUserJoiningToPlan } = data;

  const params = { isHotelUserJoiningToPlan: isHotelUserJoiningToPlan };
  return apiRequest(USER_PLAN_SERVICE_METHOD.patchPlans, data.payload, thunkApi, [id], params);
});

export const PlanDetailSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    clearPlanDetail(state) {
      state.planDetails = [];
    },
    setisBookmarked(state, action) {
      state.isBookmarked = action.payload;
    },
    setCopySectionData(state, action) {
      state.copySectionData = action.payload;
    },
    setIsShareable(state, action) {
      state.isShareablePlan = action.payload;
    },
    setPlanDetailsBookmarkState(state, action) {
      state.planDetails = {
        ...(state.planDetails || {}),
        isBookmarked: action?.payload
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlanDetailAsync.pending, (state) => {
        state.planDetailShowLoader = true;
        state.status = "loading";
      })
      .addCase(fetchPlanDetailAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        if (action.meta.arg.shouldRetainData) {
          const obj: any = state.planDetails;
          state.planDetails = { ...obj, sections: action.payload?.sections };
        } else {
          state.planDetails = { inncode: action.meta.arg.innCode, ...action.payload };
        }
        state.planDetailShowLoader = false;
      })
      .addCase(fetchPlanDetailAsync.rejected, (state) => {
        state.status = "failed";
        state.planDetailShowLoader = false;
      })
      .addCase(joiningToPlanAsync.pending, (state) => {
        state.planDetailShowLoader = true;
      })
      .addCase(joiningToPlanAsync.fulfilled, (state) => {
        state.planDetailShowLoader = false;
      })
      .addCase(joiningToPlanAsync.rejected, (state) => {
        state.planDetailShowLoader = false;
      })
      .addCase(fetchImplementedPlansAsync.pending, (state) => {
        state.implementedPlansLoader = true;
      })
      .addCase(fetchImplementedPlansAsync.fulfilled, (state, action: any) => {
        state.implementedPlansToJoin = action.payload.implementations;
        if (!action.payload.implementations?.length) state.implementedPlansLoader = false;
      })
      .addCase(fetchImplementedPlansAsync.rejected, (state) => {
        state.implementedPlansLoader = false;
      })
      .addCase(fetchUserDetailsAsync.fulfilled, (state, action: any) => {
        state.memberDetails = action.payload.users;
        state.implementedPlansLoader = false;
      })
      .addCase(fetchUserDetailsAsync.rejected, (state) => {
        state.implementedPlansLoader = false;
      });
  }
});

export const { setisBookmarked, setCopySectionData, clearPlanDetail, setIsShareable, setPlanDetailsBookmarkState } =
  PlanDetailSlice.actions;

export default PlanDetailSlice.reducer;
